import { FC } from 'react';

import sanitizeHtml from 'sanitize-html';

import { ServerHtmlProps } from './ServerHtml.types';

const defaultOptions: sanitizeHtml.IOptions = {
  allowedTags: [
    'p',
    'b',
    'i',
    'em',
    'strong',
    'a',
    'ul',
    'ol',
    'li',
    'span',
    'br',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
  ],
  allowedAttributes: {
    a: ['href', 'target'],
    '*': ['style'],
  },
  parseStyleAttributes: false,
};

const sanitize = (rawHTML: string, options?: sanitizeHtml.IOptions): { __html: string } => ({
  __html: sanitizeHtml(rawHTML, { ...defaultOptions, ...options }),
});

export const ServerHtml: FC<ServerHtmlProps> = ({ htmlString, sanitizeOptions }) => (
  // eslint-disable-next-line react/no-danger
  <div dangerouslySetInnerHTML={sanitize(htmlString, sanitizeOptions)} />
);
